'use strict';
var importedFromBase = require('./searchImportedHelperFunctions');
const MIN_DISPLAY_VIEW = '24';
const MED_DISPLAY_VIEW = '36';
const MAX_DISPLAY_VIEW = '48';
const wishlitHelper = require('../product/wishlistHeart');
const badges = require('../product/badges');

function fixUrlQuerySintaxis(currentUrl) {
    let fixedUrl = currentUrl;
    // Reemplaza el segundo "?" por "&" (si existe)
    const firstQuestionMarkIndex = currentUrl.indexOf("?");
    const secondQuestionMarkIndex = currentUrl.indexOf("?", firstQuestionMarkIndex + 1);
    if (secondQuestionMarkIndex !== -1) {
        fixedUrl = currentUrl.substring(0, secondQuestionMarkIndex) + 
                "&" + 
                currentUrl.substring(secondQuestionMarkIndex + 1);
    }
    return fixedUrl;
}
/**
 * @description - Sets the display mode (grid or list) and make the corresponding UI changes
 */
function getSelectedDisplayOption() {
    var selectedDisplayOption = sessionStorage.getItem('displayAs');

    var productElement = $('[data-product-region]');

    if (selectedDisplayOption == 'big-grid') {
        $(document).find('.display-smaller-grid').removeClass('active-display-option');
        $(document).find('.display-bigger-grid').addClass('active-display-option');

        $.each(productElement, function () {
            $(this).removeClass('col-sm-4');
            $(this).addClass('col-sm-6');
        });
    } else if (selectedDisplayOption == 'small-grid') {
        $(document).find('.display-bigger-grid').removeClass('active-display-option');
        $(document).find('.display-smaller-grid').addClass('active-display-option');

        $.each(productElement, function () {
            $(this).removeClass('col-sm-6');
            $(this).addClass('col-sm-4');
        });
    } else {
        sessionStorage.setItem('displayAs', 'small-grid');
        $(document).find('.display-bigger-grid .fa').removeClass('active-display-option');
        $(document).find('.display-smaller-grid .fa').addClass('active-display-option');

        $.each(productElement, function () {
            $(this).removeClass('col-sm-6');
            $(this).addClass('col-sm-4');
        });
    }
}

/**
 * @description - It sets the viewed quantity depending on the session storage display-view-selected attribute
 * If there is no value on the session storage attribute, the 24 default value is used
 */
function getQuantityDisplayedOption() {
    var displayViewSelected = sessionStorage.getItem('display-view-selected');

    if (displayViewSelected === MIN_DISPLAY_VIEW) {
        $('.option-view').removeClass('active-option');
        $('.option-min-products').addClass('active-option');
    } else if (displayViewSelected === MED_DISPLAY_VIEW) {
        $('.option-view').removeClass('active-option');
        $('.option-medium-products').addClass('active-option');
    } else if (displayViewSelected === MAX_DISPLAY_VIEW){
        $('.option-view').removeClass('active-option');
        $('.option-max-products').addClass('active-option');
    } else {
        $('.option-view').removeClass('active-option');
        $('.option-min-products').addClass('active-option');
        sessionStorage.setItem('display-view-selected', MIN_DISPLAY_VIEW)
    }
}

/**
 * @description - returns the current history url without the 'pagination' parameters
 * @returns {string} - the cleaned up URL
 */
function getNewUrl() {
    const url = new URL(window.location.href);
    let fixSearch = fixUrlQuerySintaxis(url.search);
    const params = new URLSearchParams(fixSearch);

    params.delete('start');
    params.delete('sz');

    return url.origin + url.pathname + (params.size > 0 ? '?' + params.toString() : '');
}

function getTotalProductPages() {
    const resultCount = $('.total-products-count').data('total-products-count');

    var totalPages;

    if (resultCount >= 1) {
        var productByPage = $(document).find('.display-quantity .active-option').text();
        totalPages = Math.ceil(resultCount / productByPage);
        localStorage.setItem('total-Pages', totalPages);
    } else {
        totalPages = 0;
    }


    return totalPages;
}

/**
 * @description - Returns the currentPagePagination attribute of the localStorage
 * If no value is found, then returns 1
 * @returns {number} - the pagination number
 */
function getCurrentPagePagination() {
    if(localStorage.getItem('currentPagePagination')) {
        return parseInt(localStorage.getItem('currentPagePagination'), 10);
    }

    return 1;
}

/**
 * @description - Updates the currentPagePagination attribute on the localStorage
 * @param {number} currentPage - the page number to be set
 */
function setCurrentPagePagination(currentPage) {
    localStorage.setItem('currentPagePagination', parseInt(currentPage, 10));
}

/**
 * @description - Returns the currentUrl attribute of the localStorage
 * @returns {string} currentUrl - the currentUrl attribute value
 */
function getCurrentUrl() {
    return localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href;
}

/**
 * @description - Updates the currentUrl attribute on the localStorage
 * @param {string} currentUrl - the currentUrl attribute value
 */
function setCurrentUrl(currentUrl) {
    localStorage.setItem('currentUrl', currentUrl);
}

function resolveURLForPagination(baseUrl, startPos, productsByPage) {
    const baseUrlObj = new URL(baseUrl);
    const params = new URLSearchParams(baseUrlObj.search);

    if(startPos) {
        params.set('start', startPos);
    }

    if(productsByPage) {
        params.set('sz', productsByPage);
    }

    return baseUrlObj.origin + baseUrlObj.pathname + '?' + params.toString();
}

function generatePaginationElement(baseUrl, currentPage, startItem, productByPage) {
    return `<li class="page-items show-items-page page-container-${currentPage}">
                <button class="page-link page-${currentPage}"
                    data-url="${resolveURLForPagination(baseUrl, startItem, productByPage)}"
                    data-page-number="${currentPage}">${currentPage}</button>
            </li>`;
}

/**
 * @description - Generates the pagination buttons to be appended on the search result bottom section
 */
function createPaginationUrl() {
    var baseUrl = getNewUrl();
    var currentPagePagination = getCurrentPagePagination();
    var productByPage = $(document).find('.display-quantity .active-option').text() || '6';
    var totalPages = getTotalProductPages();

    var currentPage;
    var activePage;
    var startItem;
    var page;

    if (totalPages <= 5) {
        startItem = 0;
        activePage = '.page-' + ' .page-link';

        for (page = 1; page <= totalPages; page++) {
            const newElement = generatePaginationElement(baseUrl, page, startItem, productByPage);
            $('.pagination .next-page').before(newElement);

            startItem += +productByPage;
        }

        $(activePage).addClass('active');
    } else if (totalPages >= 6) {
        var lastPageItems = productByPage * (totalPages - 1);
        var renderPages = 3;

        if (currentPagePagination == 1) {
            currentPage = currentPagePagination + 1;
            startItem = productByPage * currentPagePagination;
            renderPages = 2;
        } else if (currentPagePagination == 2) {
            renderPages = 2;
            currentPage = currentPagePagination;
            startItem = productByPage * (currentPagePagination - 1);
        } else if (currentPagePagination == (totalPages - 1)) {
            renderPages = 2;
            currentPage = currentPagePagination - 1;
            startItem = productByPage * (currentPagePagination - 2);
        } else if (currentPagePagination == totalPages) {
            renderPages = 2;
            currentPage = currentPagePagination - 2;
            startItem = productByPage * (currentPagePagination - 3);
        } else {
            currentPage = currentPagePagination - 1;
            startItem = productByPage * (currentPagePagination - 2);
        }

        const firstPage = generatePaginationElement(baseUrl, 1, null, productByPage);

        $('.pagination .next-page').before(firstPage);

        var dots = '<li class="page-items show-items-page">' +
            '<button class="page-link dots">' + '...' + '</button>' +
            '</li>';

        if (currentPagePagination > 3) {
            $('.pagination .page-container-1').after(dots);
        }

        for (var page = 1; page <= renderPages; page++) {
            let newPage = generatePaginationElement(baseUrl, currentPage, startItem, productByPage);

            startItem += +productByPage;
            currentPage++;

            $('.pagination .next-page').before(newPage);
        }

        var lastPage = generatePaginationElement(baseUrl, totalPages, lastPageItems, productByPage);
        $('.pagination .next-page').before(lastPage);

        $(activePage).addClass('active');

        if (currentPagePagination <= (totalPages - 3)) {
            $('.pagination .page-container-' + totalPages).before(dots);
        }
    }
}

function deleteOldElements () {
    $('.product-grid').empty();
}

function scrollToBegin() {
    $('html, body').animate({
        scrollTop: $("body").offset().top
    }, 1000);
}

function getNewResponseHtmlBody(response) {
    if (response.includes('class="row product-grid"')) {
        var newHtmlContent = response.split('class="row product-grid"')[1].split('<footer')[0];
        var newResponse = '<div class="row product-grid"' + newHtmlContent;

        return newResponse;
    } else if (response.split('search-results">').length > 1) {
        var newHtmlContent = response.split('search-results">')[1].split('<footer')[0];
        var newResponse = '<div class="container-fluid search-results">' + newHtmlContent ;

        return newResponse;
    } else {
        let productGrid = document.createElement('div');
        productGrid.className = 'row product-grid';
        productGrid.innerHTML += response;
        productGrid.innerHTML += '<span class="d-none" id="endOfProductGridRegion"></span>';
        return productGrid.outerHTML;
    }
}

/**
 * @description - Adds the 'active' class to the active page pagination button
 * @param {number} activePage - the active page number
 */
function setCurrentPageActiveStyles(activePage) {
    const currentActivePage = getCurrentPagePagination();
    var currentPageContainer = '.page-container-' + currentActivePage;
    $(currentPageContainer).addClass('active');
}

/**
 * @description - Performs an ajax search call based on the currentUrl attribute of the localStorage
 * and calls different methods that set the UI
 * @param {object} data - data object to be added to the ajax search engine call
 * @param {boolean} animate - defines if a scroll to top animation should be executed
 */
function showByPage(data, animate) {
    const currentUrlStorage = localStorage.getItem('currentUrl');
    const currentActivePage = getCurrentPagePagination();
    let fixedUrl = fixUrlQuerySintaxis(currentUrlStorage);

    $.spinner().start();
    $.ajax({
        url: fixedUrl,
        data: data,
        method: 'GET',
        success: function (response) {
            deleteOldElements();
            let newHtmlContent = getNewResponseHtmlBody(response);
            importedFromBase.updateSortOptions(response);
            $('.product-grid').replaceWith(newHtmlContent);
            setCurrentPagePagination(currentActivePage);
            getSelectedDisplayOption();
            getQuantityDisplayedOption();
            createPaginationUrl();
            setCurrentPageActiveStyles();

            // Restaurar el estado de los productos en la wishlist
            wishlitHelper.updateHeartButtons(true);

            localStorage.setItem('params', null);

            if(animate) {
                $('html, body').animate({ scrollTop: $("body").offset().top }, 1000);
            }

            badges.plpStructureOldBadges();

            $.spinner().stop();


        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function showNextOrPrevious(url, position) {
    var currentPagePagination = getCurrentPagePagination();
    var totalPages = getTotalProductPages();
    if (currentPagePagination > 1 && position == 'previous') {
        currentPagePagination -= 1;
    } else if (currentPagePagination < totalPages && position == 'next') {
        currentPagePagination += 1;
    } else {
        return;
    }

    if (currentPagePagination >= 1 && currentPagePagination <= totalPages) {
        var showPrevOrNextPage = url;
        $.spinner().start();

        $('html, body').animate({
            scrollTop: $("body").offset().top
        }, 1000);

        $.ajax({
            url: showPrevOrNextPage,
            data: { selectedUrl: showPrevOrNextPage },
            method: 'GET',
            success: function (response) {
                deleteOldElements();
                var newHtmlContent = getNewResponseHtmlBody(response);
                importedFromBase.updateSortOptions(response);
                $('.product-grid').replaceWith(newHtmlContent);
                setCurrentPagePagination(currentPagePagination);
                getSelectedDisplayOption();
                getQuantityDisplayedOption();
                createPaginationUrl();
                setCurrentPageActiveStyles();
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        return;
    }
}

/**
 * @description - retrieves the product quantity to be displayed from sessionStorage
 * If no value is found, the 24 default value is returned
 * @returns {string} - the selected product quantity to be displayed
 */
function getCurrentViewQuantity() {
    if(sessionStorage.getItem('display-view-selected')) {
        return sessionStorage.getItem('display-view-selected');
    }else {
        return MIN_DISPLAY_VIEW;
    }
}

function handlePreviousAndNext(evt, e) {
    e.preventDefault();
    let currentPagePagination = getCurrentPagePagination();

    if (evt === 'next') {
        currentPagePagination += 1
    } else if (evt === 'previous') {
        currentPagePagination -= 1
    } else {
        return;
    }

    const targetPage = '.page-link.page-' + currentPagePagination;
    const targetPageUrl = $(targetPage).data('url');
    if (targetPageUrl) {
        localStorage.setItem('currentUrl', targetPageUrl);
        setCurrentPagePagination(currentPagePagination);
        showByPage({ selectedUrl: targetPageUrl }, true);
        updateSearchUrl(targetPageUrl);
    }
}

function handleGridSize(target) {
    var productElement = $('[data-product-region]');
    var gridSize;
    if(target.hasClass('display-smaller-grid')) {
        $(document).find('.display-bigger-grid').removeClass('active-display-option');
        $(document).find('.display-smaller-grid').addClass('active-display-option');
        $.each(productElement, function () {
            $(this).removeClass('col-sm-6');
            $(this).addClass('col-sm-4');
        });
        gridSize = 'small-grid';
    }
    if(target.hasClass('display-bigger-grid')) {
        $(document).find('.display-smaller-grid').removeClass('active-display-option');
        $(document).find('.display-bigger-grid').addClass('active-display-option');
        $.each(productElement, function () {
            $(this).removeClass('col-sm-4');
            $(this).addClass('col-sm-6');
        });
        gridSize = 'big-grid';
    }
    sessionStorage.setItem('displayAs', gridSize);
}

function handleShowFilters(event) {
    if(event.type == 'mouseenter') {
        $(event.currentTarget).find('.card-body').addClass('active-filter-search');
        $(event.currentTarget).find('.card-header').addClass('hovered');
    }
    if (event.type == 'mouseleave') {
        $(event.currentTarget).find('.card-body').removeClass('active-filter-search');
        $(event.currentTarget).find('.card-header').removeClass('hovered');
    }
}

function handleActiveFilters() {
    $.each($('.refinement-bar .card-body'), function() {
        var icon = $(this).find('.fa');

        $.each(icon, function() {
            var activeFilter = $(this).parents('.card-body').siblings('.card-header');
            if ($(this).hasClass('fa-check-square')) {
                if (!activeFilter.hasClass('active-filter')) {
                    activeFilter.addClass('active-filter');
                    $('[data-reset-button]').removeClass('d-none')
                }
            }
        });
    });
}

function scrollPositionSaved(scrollPositionSavedValue) {
   setTimeout(
      function() {
        $('html, body').animate({
          scrollTop: scrollPositionSavedValue
        }, 500);
      }, 500);
  localStorage.setItem("plpScrollPositionSavedRyk", '');
  localStorage.setItem("urlPaginationPDP", '');
}

/**
 * @description - Generates an URL from the window.location.href and sets the query parameters of an incoming URL string.
 * Updates the window history with the resulting new url and set it on the local storage
 * @param {string} stringUrl - Incoming string url
 */
function updateUrl(stringUrl) {
    const currentUrl = new URL(window.location.href);
    const url = new URL(stringUrl);
    const currentQueryParams = new URLSearchParams(currentUrl.search);

    //add existing params
    for (const entry of currentQueryParams.entries()) {
      url.searchParams.set(entry[0], entry[1]);
    }

    window.history.pushState({}, '', url);
}

/**
 * @description - Generates an URL from the window.location.href, removing its query string parameters 
 * Sets the query parameters of an incoming URL string and the 'sz' parameter.
 * Updates the window history with the resulting new url and set it on the local storage
 * @param {string} stringUrl - Incoming string url
 */
function updateSearchUrl(stringUrl) {
    let decodeUrl = decodeURIComponent(stringUrl);
    let fixedUrl = fixUrlQuerySintaxis(decodeUrl);
    const queryString = fixedUrl.split('?')[1];
    const queryParams = new URLSearchParams(`?${queryString}`);
    const url = new URL(window.location.href);
    const currentQueryParams = new URLSearchParams(url.search);

    // deletes old params
    for (const entry of currentQueryParams.entries()) {
      if (!queryParams.has(entry[0])) {
        url.searchParams.delete(entry[0]);
      }
    }

    // add/update params
    for (const [key, value] of queryParams.entries()) {
        // Si el valor ya está codificado, no lo vuelvas a codificar
        const decodedValue = decodeURIComponent(value);
        const isEncoded = decodedValue !== value;
        url.searchParams.set(key, isEncoded ? value : encodeURIComponent(value));
    }

    url.searchParams.set('sz', getCurrentViewQuantity());
    window.history.pushState({}, '', decodeURIComponent(url));
    setCurrentUrl(decodeURIComponent(url));
}

module.exports = {
    createPaginationUrl: createPaginationUrl,
    getNewResponseHtmlBody: getNewResponseHtmlBody,
    getQuantityDisplayedOption: getQuantityDisplayedOption,
    getSelectedDisplayOption: getSelectedDisplayOption,
    handleActiveFilters: handleActiveFilters,
    handleGridSize: handleGridSize,
    handleShowFilters:handleShowFilters,
    handlePreviousAndNext:handlePreviousAndNext,
    scrollToBegin:scrollToBegin,
    setCurrentPageActiveStyles:setCurrentPageActiveStyles,
    showByPage:showByPage,
    getNewUrl:getNewUrl,
    getCurrentUrl: getCurrentUrl,
    setCurrentUrl: setCurrentUrl,
    getCurrentPagePagination: getCurrentPagePagination,
    setCurrentPagePagination: setCurrentPagePagination,
    getCurrentViewQuantity: getCurrentViewQuantity,
    updateUrl: updateUrl,
    updateSearchUrl: updateSearchUrl,
    generatePaginationElement
}
